/* eslint @backstage/no-undeclared-imports: 0 */
import { Alert } from '@backstage/ui';
import { MarkdownContent } from '@backstage/core-components';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

export const NoticeBannerFieldSchema = makeFieldSchema({
  output: z => z.undefined(),
  uiOptions: z =>
    z.object({
      status: z.enum(['info', 'warning', 'danger', 'success']).default('info'),
      title: z.string(),
      message: z.string(),
    }),
});

type NoticeBannerProps = typeof NoticeBannerFieldSchema.TProps;

// Display-only scaffolder field that renders a themed alert banner with a
// title and markdown message. Collects no data.
//
// Example usage in a template:
//   pimReminder:
//     type: string
//     ui:field: NoticeBanner
//     ui:options:
//       status: warning
//       title: Activate PIM before continuing
//       message: Open [Azure PIM](https://portal.azure.com/...) and activate the required role.
//     ui:backstage:
//       review:
//         show: false
export const NoticeBanner = ({ uiSchema }: NoticeBannerProps) => {
  const options = uiSchema?.['ui:options'];

  return (
    <Alert
      status={options?.status ?? 'info'}
      icon
      title={options?.title}
      description={<MarkdownContent content={options?.message ?? ''} />}
    />
  );
};
